import icons from './icons.json'
import { dialogLabels } from '~/contents/benefits'

export const primecare_plus: BenefitStoreContext[string] = {
	short_description: 'This plan provides you with instant access to high-quality healthcare.',
	description: 'Primecare covers you and your staff with quality health care',
	product_title: 'Unlock access to quality health cover',
	card_label:
		'Premier healthcare at mcg_price/month, unlimited benefits, 24/7 telemedicine, extensive specialist care for chronic conditions and emergencies.',
	dialogLabels,
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				'You can start using your benefits 24 hours after receiving your HMO ID.',
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			]
		},
		'Total Hospitals': {
			icon: icons.hospital,
			isOpen: false,
			value: [{ text: 'Your staff gains access to over 1200 hospitals across Nigeria.' }],
			key: 'hospital'
		},
		'Your Business Will Enjoy': {
			icon: icons.business,
			isOpen: false,
			value: [
				'Unlimited total benefit limits per policy.',
				'24/7 Healthcare Access: Free chats with doctors and nurses anytime, plus a free telemedicine app.',
				'Chronic Condition Coverage: Specialist consultations, medication, hospital admissions, and essential health equipment (BP machines, glucometers, trackers) covered.',
				'Accident and Emergency Care: Resuscitative care, ICU services, ambulance transportation, and necessary investigations covered.',
				'Fertility and Maternity Services: Fertility treatments up to ₦200,000, antenatal care, normal and assisted deliveries, C-sections, and neonatal care covered.',
				'Specialist and Preventive Care: Specialist consultations, surgeries up to ₦3,500,000, dental care up to ₦200,000, and comprehensive wellness checks included.',
				'A digital HMO ID for each person.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Access to general and specialist consultations.',
				'Consultations: Access to general and specialist consultations.',
				'24-Hour Telemedicine Services: Free chats with doctors and nurses and access to a telemedicine app for emergencies and routine information.',
				'Chronic Condition Coverage: General and specialist consultations, medication delivery, hospital admissions, laboratory tests, and personal health equipment (BP machines, glucometers, trackers) provided on medical diagnosis.',
				'Fertility Services: Investigation and treatments up to ₦200,000 annually.',
				'Family Planning: Coverage for contraceptives, including Copper T, Lippes loop, injectables, oral contraceptives, and Norplant.',
				'Immunisation for Children (0-5 years): Includes BCG, OPV, DPT, IPV, Vitamin A, pentavalent vaccine, measles, yellow fever, typhoid, meningitis, chickenpox, and pneumococcal vaccines.',
				'Additional Immunisation (6 years and above): Covers HPV vaccine and Hepatitis B.',
				'Ambulance Services: Resuscitative care and transportation for accident and emergency cases, including necessary investigations before ICU transfer.',
				'Intensive Care Unit (ICU) Access: Includes care for comatose patients, ventilator care, pain management, and maintenance treatment for chronic conditions for up to 10 days.',
				'Diagnostic Services: Coverage for X-rays, ultrasounds, CT scans, MRI scans, echocardiography, and electrocardiography.',
				'Laboratory Tests: Includes haematology, chemistry, microbiology, and serology.',
				'Admissions and Accommodation: Private ward admissions, feeding, accommodation for parents of admitted infants (7 days), and in-patient care abroad up to ₦450,000.',
				'Personal Health Equipment: Provision of BP machines, glucometers, and trackers on medical diagnosis.',
				'Ear, Nose & Throat (ENT) Care: Specialist consultations, treatment of acute and chronic diseases, and ENT surgeries (part of the surgical limit).',
				'Eye Care: Specialist consultations, routine ocular exams, treatment of ocular infections, and lenses coverage up to ₦55,000.',
				'Dental Care: Primary and secondary dental care up to ₦200,000, including various treatments and surgeries.',
				'Physiotherapy Care: Up to 30 sessions, including pain therapy and prescribed drugs.',
				'Surgeries: Coverage for minor, intermediate, and major surgeries up to ₦3,500,000.',
				'Obstetrics Care: Antenatal care, normal and assisted deliveries, C-sections, and reimbursement for deliveries abroad ($180 for normal delivery, $300 for C-sections).',
				'Neonatal Care: Male circumcision, ear piercing, intensive care for 25 days up to ₦750,000.',
				'Renal Care: Dialysis for up to 20 sessions annually.',
				'Cancer Care: Consultation, admission, chemotherapy, radiotherapy, and hospice care up to ₦3,000,000.',
				'Wellness Checks: Includes BMI, general physical examination, visual acuity, blood pressure, blood sugar, genotype, blood group, HIV, urinalysis, serum cholesterol, ALT/AST, prostate screening, and mammograms.',
				'HIV Care and Treatment: Specialist consultations, drug therapy, and psychotherapy at designated centres.',
				'Mental Health: Specialist consultations for outpatient cases up to 12 weeks and psychiatry care for outpatient mental illness cases up to 6 weeks.',
				'Lifestyle Management: 15% discount on non-network gym membership and network gym access for 2 sessions per week.',
				'Death Cover and Mortuary Services: After-demise care up to ₦250,000 and death cover benefits.',
				'Travel and Life Insurance: Worldwide travel insurance for 30 days, life insurance cover for death, critical illness, and permanent disability up to ₦500,000.'
			],
			need_to_know: [
				'Renewing your plan consistently helps you keep all the benefits without losing them.',
				'Any treatments, tests, procedures, and benefits not listed are not covered, and we will not bear liability for them.',
				'You can use the telemedicine option by simply calling a doctor via the platform.',
				'This is an insurance product and it adheres to standard insurance procedures.',
				'This plan is a periodic subscription that renews automatically for card transactions as long as the registered card is funded. Upon renewal, the payment will be deducted from your registered card or funded wallet. You can cancel the auto-renewal at any time by contacting our support team.',
				`You can start using your benefits ${WAITING_PERIOD} hours after receiving your HMO ID.`,
				'Please note that the plan does not cover certain exclusions.',
				'When you or your staff arrive at any of the hospitals, tell them you are from Bastion. If you experience any delay, call 09070008899'
			],
			'How to get covered': [
				'Purchase the plan and add your staff.',
				'Ask the policyholders (your staff) to activate their plans, or do it yourself from your dashboard.',
				'After activation, the e-HMO ID will be automatically generated.',
				`${WAITING_PERIOD} hours after activation, your staff can present their HMO ID at any of the hospitals under the plan to receive healthcare.`
			]
		}
	}
}
